/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRectangleFilled = createReactComponent("rectangle-filled", "IconRectangleFilled", [
  [
    "path",
    {
      d: "M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z",
      fill: "currentColor",
      key: "svg-0",
      strokeWidth: "0"
    }
  ]
]);

export { IconRectangleFilled as default };
//# sourceMappingURL=IconRectangleFilled.js.map
